// extracted by mini-css-extract-plugin
export default {"logo":"TaTwebeV3Y22Z29Cn8uY","light":"WR4aMZvQcVsnw6UoCwZb","dark":"DhhA1zxJDz8Q6ffb4yDF"};